import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Shared/Common/Button';
import { ThemeContext } from 'styled-components';
import { Tooltip } from 'antd';
import Badge from 'components/Shared/Common/Badge';

const MenuIconButton = (props) => {
    const {
        iconName,
        iconData,
        isSelected = false,
        defaultColor = 'lighten',
        selectedColor = 'lighten',
        tooltipLabel = '',
        onClick,
        href,
        className = '',
        iconBgColor,
        notificationCount = 0,
        target,
        id
    } = props;
    const { mainColor2 } = useContext(ThemeContext);
    const color = isSelected
        ? selectedColor
        : defaultColor;

    return (
        <Tooltip placement="right" title={`${tooltipLabel}`}>
            <div className={`item ${className}`} id={id}>
                <Badge maxCount={999} count={notificationCount} offset={[-24, 7]} size="small">
                    <Button
                        iconName={iconData ? undefined : iconName}
                        onClick={onClick}
                        href={href}
                        color={color}
                        isTransparent
                        iconBgColor={iconBgColor === 'primary' ? mainColor2 : undefined}
                        target={target}
                    >
                        {iconData && (
                            <img
                                style={{
                                    height: 24,
                                    maxWidth: '100%',
                                    display: 'block'
                                }}
                                src={iconData}
                                alt={tooltipLabel}
                            />
                        )}
                    </Button>
                </Badge>
            </div>
        </Tooltip>
    );
}

MenuIconButton.propTypes = {
    iconName: PropTypes.string,
    iconData: PropTypes.string,
    onClick: PropTypes.func,
    href: PropTypes.string,
    id: PropTypes.string,
    isSelected: PropTypes.bool,
    defaultColor: PropTypes.string,
    selectedColor: PropTypes.string,
    iconBgColor: PropTypes.string,
    className: PropTypes.string,
    tooltipLabel: PropTypes.string,
    notificationCount: PropTypes.number,
    target: PropTypes.string
};

export default memo(MenuIconButton);
